<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-sm-12 align-content-center text-center mb-3">
        <button class="btn btn-primary mr-1" @click="updateStatus('active')">Approve</button>
        <button class="btn btn-danger mr-1" @click="updateStatus('rejected')">Reject</button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-lg-4">
            <div class="card">
              <div class="card-body">
                <div class="form-group">
                  <label class="control-label">Nama: </label><br>
                  <span><b>{{ relungkuData.product_name }}</b></span>
                </div>
                <div class="form-group">
                  <label class="control-label">Harga: </label><br>
                  <span><b>{{ relungkuData.price }}</b></span>
                </div>
                <div class="form-group">
                  <label class="control-label">Type:</label><br>
                  <span><b>{{ relungkuData.product_type.toUpperCase() }}</b></span>
                </div>
                <div class="form-group">
                  <label class="control-label">Deskripsi:</label><br>
                  <span><b>{{ relungkuData.description }}</b></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="card">
              <div class="card-body">
                <object :data="pdfBlob" width="100%" height="700"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "relungku-view",
  page: {
    title: "Lihat Relungku",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Lihat Relungku',
      items: [
        {
          text: 'Relungku',
          href: '/',
        },
        {
          text: 'Lihat Relungku',
          active: true,
        },
      ],
      relungkuData: {},
      pdfBlob: null
    }
  },
  methods:{
    fetchRelungkuData() {
      axios.get("/api/product/"+this.$route.params.id)
          .then(resp => {
            const { data } = resp.data
            this.relungkuData = data
            this.fetchProductData()
          });
    },
    fetchProductData() {
      let url = ""
      switch (this.relungkuData.product_type) {
        case "silabus":
          url = "/api/silabus/download/"
          break
        case "lesson_plan":
          url = "/api/lesson_plan/download/"
          break
        case "penilaian":
          url = "/api/penilaian/download/"
          break
        case "rubrik":
          url = "/api/rubrik/download/"
          break
        case "strategi":
          url = "/api/strategic/download/"
          break
      }

      url = url + this.relungkuData.reference_id.toString()
      axios.get(url)
          .then(resp => {
            const { data } = resp.data
            this.pdfBlob = 'data:application/pdf;base64,'+data
          });
    },
    updateStatus(status) {
      const payload = {
        "status": status
      }
      let url = "/api/product/product_status/"+this.$route.params.id

      if (status === 'rejected') {
        Swal.fire({
          title: "Yakin, reject data ini",
          text: this.relungkuData.product_name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Reject"
        }).then(result => {
          if (result.value) {
            return axios({url: url, data: payload, method: 'PUT'})
                .then(resp => {
                  if (resp.data.status == '200 OK') {
                    Swal.fire("Sukses update data")
                    this.$router.push('/relungku')
                  } else {
                    Swal.fire("Gagal update data")
                  }
                })
          }
        });
      } else {
        return axios({url: url, data: payload, method: 'PUT'})
            .then(resp => {
              if (resp.data.status == '200 OK') {
                Swal.fire("Sukses update data")
                this.$router.push('/relungku')
              } else {
                Swal.fire("Gagal update data")
              }
            })
      }
    },
  },
  mounted() {
    this.fetchRelungkuData()
  },
}
</script>

<style scoped>

</style>